"use client";

import { logger } from "@utilities/logger";
import { useRef, useState } from "react";
import { getAudioUrl } from "@utilities/payload";
import CoverArt from "@ui/components/routes/music/CoverArt";
import { MusicColorScheme } from "@ui/components/routes/music/colorScheme";
import { AudioSample } from "@mw/shared/payload-types";

export function SingleSongMusicPlayer({ audioSample }: { audioSample?: AudioSample | null }) {
  const audioRef = useRef<HTMLAudioElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const audioUrl = getAudioUrl(audioSample?.audio);
  if (!audioUrl) return null;

  const handlePlayPause = () => {
    if (!audioRef.current) return;

    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(error => {
        logger.error(error instanceof Error ? error : null, "Failed to play audio");
      });
    }
  };

  return (
    <div className='flex h-full w-full items-center justify-center p-16 md:p-32'>
      <CoverArt
        audioElement={audioRef.current}
        boxShadow={false}
        className='w-full max-w-md'
        colorScheme={MusicColorScheme.purple}
        onClick={handlePlayPause}
        title={audioSample?.title || ""}
        styles={audioSample?.styleTags?.map(styleTag => styleTag.tag || "") || []}
      />
      {/* Hidden audio element */}
      <audio
        crossOrigin='anonymous'
        onEnded={() => setIsPlaying(false)}
        onPause={() => setIsPlaying(false)}
        onPlay={() => setIsPlaying(true)}
        preload='auto'
        ref={audioRef}
        src={audioUrl}
      />
    </div>
  );
}
